import { render, staticRenderFns } from "./BsiEntryCountdownTimerSide.vue?vue&type=template&id=4b29c28c&scoped=true"
import script from "./BsiEntryCountdownTimerSide.vue?vue&type=script&lang=js"
export * from "./BsiEntryCountdownTimerSide.vue?vue&type=script&lang=js"
import style0 from "./BsiEntryCountdownTimerSide.vue?vue&type=style&index=0&id=4b29c28c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b29c28c",
  null
  
)

export default component.exports